import api from './api';

export const lessonService = {
    getLessons: async (params = {}) => {
        return await api.get('/lessons', { params });
    },

    getLessonById: async (id) => {
        return await api.get(`/lessons/${id}`);
    },

    getLessonResources: async (id) => {
        return await api.get(`/lessons/${id}/resources`);
    },

    getLessonExperiment: async (id) => {
        return await api.get(`/lessons/${id}/experiment`);
    },

    startLesson: async (id) => {
        return await api.post(`/lessons/${id}/start`);
    },

    completeLesson: async (id, timeSpent) => {
        return await api.post(`/lessons/${id}/complete`, {
            time_spent_minutes: timeSpent
        });
    }
};